import axios from "axios";
import AxiosBase from "@/auth/axiosBase";
const baseUrl = process.env.VUE_APP_BACKEND_URL;
import { fileUploadFetch } from "@/helpers/fileUploadFetchHelper";

export default class GuestService extends AxiosBase {
  constructor() {
    super();
  }

  async GenerateOtp(model) {
    let processResult = {};
    const url = `${baseUrl}/api/IdentityGuest/auth/request-otp`;
    let requestBody = JSON.stringify(model);
    await axios
      .post(url, requestBody)
      .then((response) => {
        processResult = response;
      })
      .catch((error) => {
        console.log(error);
      });
    return processResult;
  }
  async ValidateOtp(model) {
    let processResult = {};
    const url = `${baseUrl}/api/IdentityGuest/auth/verify-otp`;
    let requestBody = JSON.stringify(model);
    await axios
      .post(url, requestBody)
      .then((response) => {
        processResult = response;
      })
      .catch((error) => {
        console.log(error);
      });
    return processResult;
  }
  async LogoutGuest() {
    let processResult = {};
    const url = `${baseUrl}/api/IdentityGuest/auth/logout`;
    await axios
      .post(url)
      .then((response) => {
        processResult = response;
      })
      .catch((error) => {
        console.log(error);
      });
    return processResult;
  }

  async GetGuestTypes() {
    let result = {};
    const url = `${baseUrl}/api/IdentityGuest/guest/guest-types`;
    await axios.get(url)
      .then((response) => {
        result = response;
      }).catch((error) => {
        console.log(error);
      });
    return result;
  }

  async GetGuestPersonalInfoById() {
    let result = {};
    const url = `${baseUrl}/api/IdentityGuest/guest/get-guest-personal_info`;
    await axios.get(url)
      .then((response) => {
        result = response;
      }).catch((error) => {
        console.log(error);
      });
    return result;
  }

  async AddOrUpdateGuestPersonalInfo(model) {
    let processResult = {};
    const url = `${baseUrl}/api/IdentityGuest/guest/add-guest-personal-info`;
    let requestBody = JSON.stringify(model);
    await axios
      .post(url, requestBody)
      .then((response) => {
        processResult = response;
      })
      .catch((error) => {
        console.log(error);
      });
    return processResult;
  }
  async AddGuestDetail(model) {
    let processResult = {};
    const url = `${baseUrl}/api/IdentityGuest/guest/add-guest-detail`;
    let requestBody = JSON.stringify(model);
    await axios
      .post(url, requestBody)
      .then((response) => {
        processResult = response;
      })
      .catch((error) => {
        console.log(error);
      });
    return processResult;
  }
  
  async GetGuestPhoto() {
    let result = {
      imageSrc: "",
      hasCustomPhoto: false,
    };
    const url = `${baseUrl}/api/IdentityGuest/guest/get-guest-photo`;
    await axios
      .get(url)
      .then((response) => {
        const data = response?.data?.responseData;
        if (data?.photoBytes) {
          result.imageSrc = "data:image/jpeg;base64," + data.photoBytes;
        }
        result.hasCustomPhoto = !!data?.hasCustomPhoto;
      })
      .catch((error) => {
        console.log(error);
      });

    return result;
  }

  async SaveResizeImageGuest(formData) {
    const url = `${baseUrl}/api/IdentityGuest/guest/save-resize-image-guest`;
    return fileUploadFetch(url, formData);
  }
}